import {
  SubPageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';

const petrolPricesFeedPage = SubPageBlueprint.make({
  attachTo: { id: 'page:devtools', input: 'pages' },
  name: 'petrol-prices-feed',
  params: {
    path: 'petrol-prices-feed',
    title: 'Petrol Prices Feed',
    loader: async () => {
      const [{ Content }, { PetrolPricesFeedStatus }] = await Promise.all([
        import('@backstage/core-components'),
        import('./PetrolPricesFeedStatus'),
      ]);
      return (
        <Content>
          <PetrolPricesFeedStatus />
        </Content>
      );
    },
  },
});

export const petrolPricesDevToolsModule = createFrontendModule({
  pluginId: 'devtools',
  extensions: [petrolPricesFeedPage],
});
